/**
 * Page Position Constraint Types
 * Define how pages can be positioned relative to other pages
 */
export enum PagePositionConstraintType {
  AtIndex = 'at-index',
  After = 'after',
  Before = 'before',
  Between = 'between',
}

/**
 * Block Position Constraint Types
 * Define how blocks can be positioned on pages and relative to other blocks
 */
export enum BlockPositionConstraintType {
  // PAGE-BASED CONSTRAINTS (require page properties)
  AfterPage = 'after-page',
  OnPage = 'on-page',
  BeforePage = 'before-page',
  BetweenPages = 'between-pages',

  // PURE BLOCK-BASED CONSTRAINTS (require only block properties)
  AfterBlock = 'after-block',
  BeforeBlock = 'before-block',
  SamePageAsBlock = 'same-page-as-block',
}
